export default {
  namespaced: true,
  state: {
    corpId: null,
    userId: null,
  },
  mutations: {
    SET_CORP_ID(state, payload) {
      state.corpId = payload;
    },
    SET_USER_ID(state, payload) {
      state.userId = payload;
    },
    INIT(state) {
      state.corpId = null;
      state.userId = null;
    }
  },
  getters: {
    getCorpId(state) {
      return state.corpId;
    },
    getUserId(state) {
      return state.userId;
    }
  },
  actions: {
    setCorpId({commit}, payload) {
      commit('SET_CORP_ID', payload);
    },
    setUserId({commit}, payload) {
      commit('SET_USER_ID', payload);
    },
    init({commit}) {
      commit('INIT');
    }
  }
}